import { useSelector } from "react-redux";
import { getPharmacyInfo } from "../common/getPharmacyInfo";
import { Section, Divider, H2, DataField } from "./common-components";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const PharmacyInformation = ({ formType }) => {
  const { currentLoggedInUserDetail: userFromCurrentState } = useSelector((state) => state.currentLoggedInUserDetail ?? {});
  const usersState = useSelector((state) => state.users);
  const { currentLoggedInUserDetail: userFromUsers, pharmacyStores } = usersState ?? {};
  const currentLoggedInUserDetail = userFromCurrentState ?? userFromUsers;
  const pharmacy = getPharmacyInfo(currentLoggedInUserDetail, pharmacyStores) ?? {};

  const pharmacyName = pharmacy.pharmacyName ?? "-";
  const pharmacyStoreNumber = pharmacy.pharmacyStoreNumber ?? "";
  const pharmacyPhone = pharmacy.pharmacyPhone ?? "";
  const pharmacyEmail = pharmacy.pharmacyEmail ?? "";
  const pharmacyFax = pharmacy.pharmacyFax ?? "";
  const pharmacyAddress = pharmacy.pharmacyAddress ?? "";

  return (
    <Section className="space-y-[0.0833333in]" formType={formType}>
      <H2>Pharmacy Information</H2>
      <div className="grid grid-cols-2 gap-[0.0833333in]">
        <DataField label="Pharmacy Name" value={pharmacyName} />
        <DataField label="Store #" value={pharmacyStoreNumber} />
      </div>
      {[AllergicRhinitisDocTypes.InitialAssessment, MedicationReviewDocTypes.PharmacistWorksheet].includes(formType) ? (
        <>
          <Divider />
          <div className="grid grid-cols-2 gap-[0.0833333in]">
            <DataField label="Phone" value={pharmacyPhone} />
            <DataField label="Email" value={pharmacyEmail} />
          </div>
          <div className="grid grid-cols-2">
            <DataField label="Fax" value={pharmacyFax} />
            <DataField label="Address" value={pharmacyAddress} />
          </div>
        </>
      ) : null}
    </Section>
  );
};
